import React from "react"
import { useFormSubmissionReportExportContext } from "contexts/FormSubmissionReportExportContext"
import { SELECT_TYPE, SELECT_CSV_TYPE, MULTI_SELECT_TYPE } from "views/Forms/FormElementTypes"
import { MultiSelect } from "shared/multiSelects"
import SelectAnswerFilterAnswerPicker from "./SelectAnswerFilterAnswerPicker"

export const SELECT_QUESTION_TYPES = [SELECT_TYPE, SELECT_CSV_TYPE, MULTI_SELECT_TYPE]

const NewFormSubmissionReportExportFormSelectAnswerFilters = () => {
  const {
    questions,
    selectAnswerFilters,
    toggleSelectAnswerFilterQuestion,
  } = useFormSubmissionReportExportContext()

  const selectQuestions = questions.filter((question) => SELECT_QUESTION_TYPES.includes(question.type))

  if (selectQuestions.length === 0) {
    return (
      <p>There are no select questions on the form associated with this report.</p>
    )
  }

  const selectedQuestionUuids = selectAnswerFilters.map((f) => f.questionUuid)

  const handleChange = (uuids) => {
    const added = uuids.find((uuid) => !selectedQuestionUuids.includes(uuid))
    const removed = selectedQuestionUuids.find((uuid) => !uuids.includes(uuid))

    if (added) toggleSelectAnswerFilterQuestion(added)
    if (removed) toggleSelectAnswerFilterQuestion(removed)
  }

  return (
    <div className="w-full">
      <MultiSelect
        className="!w-full bordered-base-input"
        label="select questions to filter by"
        onChange={handleChange}
        options={selectQuestions.map((q) => ({ label: q.prompt, value: q.uuid }))}
        placeholder="Select questions..."
        searchable
        values={selectedQuestionUuids}
      />
      {selectAnswerFilters.length > 0 && (
        <div className="mt-4">
          <span className="block mb-4">Questions:</span>
          <div className="flex flex-col gap-4">
            {selectAnswerFilters.map((filter) => (
              <SelectAnswerFilterAnswerPicker key={filter.questionUuid} questionUuid={filter.questionUuid} />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default NewFormSubmissionReportExportFormSelectAnswerFilters
